export const PHONE_NUMBER_REGEX = /^\(\d{3}\) \d{3}-\d{4}$/;

export const SSN_REGEX = /^\d{3}-\d{2}-\d{4}$/;

export const VALID_CURRENCY_INPUT_REGEX = /^\$?[0-9,]*\.?[0-9]*$/;

export const DATE_INPUT_REGEX = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
